/**
 * Where on the Mac the grant and the setting are (I-1786, AC-SS.93): the place the sentences in
 * `agent-start-offer.ts` send a person to. Since the Infrastructure fold (F-0601, D-0331 (a)) it is the
 * Agents explorer's node for this machine, its Settings tab (AMX-7d). The last segment is the heading of that section in the web
 * app, and a test holds the heading, its anchor and the desktop menu's route to this wording.
 *
 * Its own module so the desktop menu's route, which is in the web app's entry, reads the anchor
 * without the whole offer (its sentences and the start contract, 10.7 KB) coming with it (T-0559).
 */
export const AGENT_START_MAC_PLACE_PATH = ['Agents', 'This machine', 'Settings'] as const;
export const AGENT_START_MAC_SECTION = 'Starting agent sessions';
export const AGENT_START_MAC_SECTION_ANCHOR = 'starting-agent-sessions';

/**
 * The on-screen label of the switch a start from another device travels through (F-0225's listener),
 * on the same page (AC-SS.100). `BrowserWatchConsent`'s heading is this, so a sentence that names it
 * names what the person sees.
 */
export const AGENT_START_WATCH_SWITCH_LABEL = 'Watch terminals from a browser';

/** The anchor of that switch's section on the same page, where a refusal naming it sends a person (I-1914). */
export const AGENT_START_WATCH_SWITCH_ANCHOR = 'watch-terminals-from-a-browser';

/**
 * ASF-19: the same places as catalogue keys (`navigation`, which every page loads), so a sentence that
 * names a place says it as the page and the sidebar do in the reader's language. The English
 * constants above are those keys' English (`agent-start-mac-place.catalogue.test.ts`).
 */
export const AGENT_START_MAC_PLACE_KEYS = [
  'navigation.account.agents',
  'navigation.infrastructureThisMachine',
  'navigation.machineSettings',
] as const;
export const AGENT_START_MAC_SECTION_KEY = 'navigation.startingAgentSessions';
export const AGENT_START_WATCH_SWITCH_KEY = 'navigation.watchTerminalsFromABrowser';
